import BaseModel from './BaseModel'

export default class RoServiceCustomer extends BaseModel {
  // ... RoServiceCustomer-specific methods or overrides ...
}
